export default __webpack_public_path__ + "static/media/omelet_tomato.58c4a718.jpg";